$(function(){
  
  /* pc & mb popup 스위치 */  
  var _oncePpopup_hamburger = $("#popup_hamburger-wrap").trpUtilityChangeOnceFn(
    function($repteat){
      var pop_pcShow_B = ($("#popup_hamburger-wrap").filter(":visible").length == 0 )? false : true; 
      var pop_mbShow_B = ($("#popup_hamburger_mb-wrap").filter(":visible").length == 0)? false : true;
      var pop_pc_B = (typeof popup_hamburger    === 'undefined') ? false : true;
      var pop_mb_B = (typeof popup_hamburger_mb === 'undefined') ? false : true;
      
      // console.log( ">>> ::: ",pop_pcShow_B  ,pop_mbShow_B,  pop_pc_B, pop_mb_B);
      if($repteat){ // pc
        if( pop_mbShow_B && pop_pc_B ){
          console.log("PC open", );
          popup_hamburger_mb.close();
          popup_hamburger.open( $(".js-popup_hamburger") );
        }
      }else{        // mb
        if( pop_pcShow_B && pop_mb_B ){
          popup_hamburger.close();
          popup_hamburger_mb.open( $(".js-popup_hamburger_mb") );
        }
      }
    }
  );


  /* 리싸이즈 공통 */
  $(window).on("resize", function(){
    responsiveDevices();        // width  : pc, mobile 체크
    responsiveScrollX();        // width  : pc, mobile 체크
    _oncePpopup_hamburger.setChange($(".body").hasClass("is_pc"));
  })
  responsiveDevices();
  responsiveScrollX();
  setTimeout(function(){
    $(window).trigger("resize");
  }, 500);

  /* ==================================== 초기UI 실행 호출함수 호출  ==================================== */
  window.pubUI = new PubUI();
  window.pubUI.gnb_set();
  window.pubUI.gnb_search_set();
  window.pubUI.sub_menu_set();

  if( $(".js-cursor_event").length ){
    window.pubUI.cursor_set();
  }
  window.pubUI.footer_scolltop_set();
  window.pubUI.append_script();

  /* 패럴럭스  Parallax */
  window.pubUI.append_parallax();
  
});


/* ==================================== 초기UI 실행 함수 호출  ==================================== */
function PubUI() {
  var _this = this;

  /* gnb_set */
  _this.gnb_set = function(){

    /* PC : dpe2_sub. width */
    $(".js-gnb_area").on("mouseenter", function($e){
      $(".js-gnb_area .menu-list .dep1").each(function($index){
        var _w = $(".dep1-inner span", this).innerWidth();
        // console.log("w ", _w)
        $(".dep2_sub-inner", this).css({ width: _w });
      })
    })


    /* MB : other_accordion */
    var other_accordion = $(".js-other_accordion .btn-acc").trpToggleBtn(
      function($this) {
        $($this).closest(".js-other_accordion").addClass("active");
        $($this).closest(".js-other_accordion").find(".area-body").slideDown("fast");
      },
      function($this) {
        $($this).closest(".js-other_accordion").removeClass("active");
        $($this).closest(".js-other_accordion").find(".area-body").slideUp("fast");
    });

    /* gnb banner */
    var gnb_subSwiper = new Swiper('.js-gnb_sub-swiper .gallery_container', {
      slidesPerView: 1,
    /*   autoplay: {
        delay: 5000,
      }, */
      loop: true,
      threshold: 20,    // 드래그 거리 이상일대 적용
      pagination: {
        el: '.js-gnb_sub-swiper .pagination',
        clickable : true,
      },
    })

  }

  /* gnb_search_set */
  _this.gnb_search_set = function(){
    $(".js-popup_search").on("click", function(){
      $(".top_search").addClass("open");
    });
    $(".js-popup_search_close").on("click", function(){
      $(".top_search").removeClass("open");
    });
  }

  /* sub_menu_set MB 전용 */
  _this.sub_menu_set = function(){

    var sub_menuToggle;
    sub_menuToggle = $(".js-dep3_title").trpToggleBtn(
      function($this) {
        $($this).closest(".dep3_sub").addClass("active").find(".dep3_sub-box").slideDown();
      },
      function($this) {
        $($this).closest(".dep3_sub").removeClass("active").find(".dep3_sub-box").slideUp("fast");
    });

  }

  /* footer_scrolltop */
  _this.footer_scolltop_set = function() {
    var scroll_top = $(".js-scroll_top").trpScrollSync({ heightTar:60, showHeight:300, bottomTar:50, bottomStop:306 });
    $(".js-scroll_top a").on("click", function($e){
      $e.preventDefault();
      $( 'html, body' ).animate( { scrollTop: 0 }, 300 );
    })
    $(window).on("scroll resize", function($e){
      if( $("body").hasClass("is_mb") ){
        scroll_top.setHeightTar( 40 );
        scroll_top.setBottomStop( $("#footer").innerHeight() - 40 );
      }else {
        scroll_top.setHeightTar( 60 );
        scroll_top.setBottomStop( $("#footer").innerHeight() );
      }
    })
  }

  /* cursor_set */
  _this.cursor_set = function() {
    var cursor = document.querySelector('.js-cursor');
    var a = $(".js-cursor_event"); 

    document.addEventListener('mousemove', function(e){
      cursor.style.transform = `translate3d(calc(${e.clientX}px - 50%), calc(${e.clientY}px - 50%), 0)`
    });

    a.on("mouseenter", function($e){
      if( $("body").hasClass("is_pc")){ cursor.classList.add('hover'); }
    });
    a.on("mouseleave", function($e){
      if( $("body").hasClass("is_pc")){ cursor.classList.remove('hover'); }
    });
  }

  /* script add */
  _this.append_script = function() {
    console.log("common.js");
    function msgFn(msg1, msg2){
      var _msg = msg1 + msg2;
      return _msg;
    }
    $("body").addClass( msgFn("msg_", "hi"));
    //$("body").append( $(".jsappend-kv_script") );
  }

  /* 패럴럭스  Parallax */
  _this.append_parallax = function() {
    $(".js-scrollmotion_up").trpScrollActive( "scrollmotion_up" , 0.03);
    $(".js-scrollmotion_left").trpScrollActive( "scrollmotion_left" , 0.03);
    $(".js-scrollmotion_right").trpScrollActive( "scrollmotion_right" , 0.03);
    $(".js-scrollmotion_zoomin").trpScrollActive( "scrollmotion_zoomin" , 0.05);
    $(".js-scrollmotion_up5").trpScrollActive( "scrollmotion_up" , 0.05);
    console.log("패럴럭스  Parallax 실행")
  }

  
}

/* ==================================== 초기실행 함수 호출  ==================================== */
var _szMB  = 1023;   // 1023
/* 호출 */
function responsiveDevices(){ 
    var _change_width = window.innerWidth; //  $(window).innerWidth(); //
    var _temp_width;      
    //console.log(_change_width)
    if( _change_width > _szMB){
      _temp_width = "is_pc";
    }else {
      _temp_width = "is_mb";
    };
    if (!$('body').hasClass(_temp_width)) {
      $("body").removeClass("is_pc is_tb is_mb is_ms");
      $("body").addClass(_temp_width);
      console.log("===============responsiveDevices=====================")
    }
    $("body").attr( "data-device" , _temp_width);
    return _temp_width
}

function responsiveScrollX(){
  /* 스크롤 바생기면 */
  $(".js-scrollbarX").trpHasScrollBarX();
  if( $(".js-ol_scrollbarX .os-scrollbar-horizontal").hasClass("os-scrollbar-unusable") ){
    $(".js-ol_scrollbarX").removeClass("scrollbar_on");
  }else{
    $(".js-ol_scrollbarX").addClass("scrollbar_on");
  }
  
}


